import React from 'react';

const Search = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill=""
    {...props}
  >
    <path
      fill={props.fill || '#437EF7'}
      fillRule="evenodd"
      d="M10.5 19a8.5 8.5 0 1 1 6.676-3.238l4.531 4.53a1 1 0 0 1-1.414 1.415l-4.531-4.531A8.463 8.463 0 0 1 10.5 19Zm4.66-3.968a1.01 1.01 0 0 0-.128.128 6.5 6.5 0 1 1 .128-.128Z"
      clipRule="evenodd"
    />
  </svg>
);
export default Search;
